import React, { createContext, useState, useEffect, startTransition } from 'react';
import { onIdTokenChanged, User } from 'firebase/auth';
import { FirebaseAuth } from './firebase/firebase';
import { AppContextInterface, IState, IUserFirebase } from '../types/interfaces';
import { Apolloclient } from './apollo/client';
import { GET_USER_ACCOUNT, INSERT_REFERRAL, UPDATE_LANGUAGE } from './apollo/queries';
import { Rewards_Referral_Insert_Input } from '../graphql/types';
import { setUser as setSentryUser, setContext } from '../utils/sentry-helpers';

// import { setUserFirebaseAuth } from "../../state/actions/user"
// import { useDispatch } from "react-redux"

// https://farhanfarooq.com/tutorials/gatsby-firebase-authentication

/** Código Plan Amigo a aplicar solo tras alta nueva (no en login). Escrito en useAuth; consumido en getUserData. */
export const REFERRAL_PENDING_REGISTRATION_KEY = 'referral_pending_registration';

export const AppCtx = createContext<AppContextInterface | any>({});

const AuthFirebaseProvider = (props: any) => {
	const [state, setState] = useState<IState>();
	const [user, setUser] = useState<IState['user']>();
	const [token, setToken] = useState<string>('');
	const [status, setStatus] = useState<string>('checking');

	const [logged, setLogged] = useState<boolean>(false);
	const [onboarding, setOnboarding] = useState<boolean>(false);
	const [isVerificationToastVisible, setIsVerificationToastVisible] = useState<boolean>(false);

	const [openAuthModal, setOpenAuthModal] = useState<boolean>(false);

	const [eventKey, setEventKey] = useState('login');

	// const [kycAccepted, setKycAccepted] = useState<boolean>(false)
	// const [kycInProgress, setKycInProgress] = useState<boolean>(false)

	// from usewindowssizw
	const [isMobile, setIsMobile] = useState<boolean>(false);
	const [isReady, setIsReady] = useState<boolean>(false);
	const [refreshUI, setRefreshUI] = useState<boolean>(false);
	const [refreshDataAccount, setRefreshDataAccount] = useState<boolean>(false);

	/************************
	 ***** First query ******
	 */

	const getUserData = (token: string, userAuth: any, user: IUserFirebase): any => {
		// console.log("toke getuser data", token);

		return Apolloclient(token)
			.query({
				query: GET_USER_ACCOUNT,
				fetchPolicy: 'network-only',
				context: { clientName: 'third-party' },
			})
			.then((res) => {
				console.log('res apollo', res);
				const userCustomBBDD: IState['user'] = { ...user, ...res.data.user[0] };
				// console.log("[getUserData] res.data.accounts[0]", res.data.accounts);

				// // sanitize
				const account_internal_wallet_web2 = res.data.accounts?.filter(
					(account: any) => account.type === 'account_internal_wallet_web2'
				);
				const account_internal_wallet_web3 = res.data.accounts?.filter(
					(account: any) => account.type === 'account_internal_wallet_web3'
				);

				// console.log(
				//   "[getUserData] account_internal_wallet_web2",
				//   account_internal_wallet_web2
				// );
				// console.log(
				//   "[getUserData] account_internal_wallet_web3",
				//   account_internal_wallet_web3
				// );

				const account_internal_wallet_web2_sanitize = {
					type: account_internal_wallet_web2[0]?.type,
					balances: account_internal_wallet_web2[0]?.balances,
					accountId: account_internal_wallet_web2[0]?.account_internal_wallet_web2?.accountId,
				};

				const account_internal_wallet_web3_sanitize = {
					type: account_internal_wallet_web3[0]?.type,
					balances: account_internal_wallet_web3[0]?.balances,
					address: account_internal_wallet_web3[0]?.account_internal_wallet_web3?.address,
				};

				const accounts = {
					account_internal_wallet_web2: account_internal_wallet_web2_sanitize,
					account_internal_wallet_web3: account_internal_wallet_web3_sanitize,
				};

				const stateTmp: IState = {
					...state,
					user: userCustomBBDD,
					accounts: accounts,
				};

				console.log('[getUserData] **SET STATE', stateTmp);

				startTransition(() => {
					setState(stateTmp);
				});

				const pendingReferral = localStorage.getItem(REFERRAL_PENDING_REGISTRATION_KEY);
				// Clave histórica: ya no se rellena en login; limpiar por si quedó en navegadores viejos
				try {
					localStorage.removeItem('referral');
				} catch {}

				const ownReferral = userCustomBBDD?.promotional_referral?.promotional_referral;
				const normalizedPendingReferral = pendingReferral?.trim().toLowerCase();
				const normalizedOwnReferral = ownReferral?.trim().toLowerCase();
				const isOwnReferral =
					normalizedPendingReferral && normalizedOwnReferral && normalizedPendingReferral === normalizedOwnReferral;
				const hasRefereeReferral = userCustomBBDD?.rewards_referrals?.some((reward: { type?: string }) => reward.type === 'referee');

				if (isOwnReferral || hasRefereeReferral) {
					localStorage.removeItem(REFERRAL_PENDING_REGISTRATION_KEY);
				} else if (pendingReferral) {
					localStorage.removeItem(REFERRAL_PENDING_REGISTRATION_KEY);

					const data: Rewards_Referral_Insert_Input = {
						promotional_referral: pendingReferral,
					};

					Apolloclient(token)
						.mutate({
							mutation: INSERT_REFERRAL,
							variables: { object: data },
							context: { clientName: 'third-party' },
						})
						.then((res) => {
							console.log('res', res);
						})
						.catch((e) => {
							console.log(e);
						});
				}

				const prefLang = localStorage.getItem('preferredLanguage');

				if (prefLang) {
					Apolloclient(token)
						.mutate({
							mutation: UPDATE_LANGUAGE,
							variables: { user_id: userCustomBBDD?.user_id, language: prefLang },
							context: { clientName: 'third-party' },
						})
						.then((res) => {
							localStorage.removeItem('preferredLanguage');
						})
						.catch((e) => {
							console.log(e);
						});
				}

				return res.data.user[0];
			})
			.catch((err) => {
				// ** CLAVE ** : LLamada recursiva para refrescar el Token
				// SE USA AL REGISTRAR NUEVO USER
				// // error con jwt credenciales
				console.log('[getUserData] error jwt', err);
				userAuth.getIdToken(true).then((newToken: string) => {
					console.log('newToken', newToken);
					localStorage.setItem('accessToken', newToken);
					setToken(newToken);
					getUserData(newToken, userAuth, user);
				});
				return false;
			});
	};

	/********************/

	// const dispatch = useDispatch()

	const signout = () => {
		localStorage.removeItem('accessToken');
		setStatus('not-authenticated');

		// Limpiar usuario de Sentry
		setSentryUser(null);
	};

	const setStateHandler = (userAuth: any, hasuraClaim: any, token: string) => {
		console.log('[onIdTokenChanged] Firebase data', userAuth);

		const userCustom = {
			providerId: userAuth.providerId,
			uid: userAuth.uid,
			stsTokenManager: userAuth.stsTokenManager,
			accessToken: userAuth.accessToken,
			displayName: userAuth.displayName,
			email: userAuth.email,
			emailVerified: userAuth.emailVerified,
			phoneNumber: userAuth.phoneNumber,
			photoURL: userAuth.photoURL,
			isAnonymous: userAuth.isAnonymous,
			tenantId: userAuth.tenantId,
			providerData: userAuth.providerData,
			metadata: userAuth.metadata,
		};
		const user: IUserFirebase = {
			...userCustom,
			hasuraClaim,
			logged: true,
			language: null,
		};

		startTransition(() => {
			setState({
				...state,
				user,
			});

			console.log('[onIdTokenChanged] **SET STATE', user);

			// Establecer usuario en Sentry
			setSentryUser({
				id: user.uid,
				email: user.email || undefined,
				username: user.displayName || user.email || undefined,
			});

			// Agregar contexto adicional
			setContext('firebase_auth', {
				provider: user.providerId,
				emailVerified: user.emailVerified,
				hasHasuraClaim: !!user.hasuraClaim,
			});

			// refresh token after login or after expire token
			localStorage.setItem('accessToken', token);
			setToken(token);

			setLogged(true);
		});

		getUserData(token, userAuth, user).then((data: any) => {
			console.log('UserData', data);

			let resultkyc = 'false';

			const acceptedKYCs = data.user?.kycs?.filter((kyc: any) => kyc.status === 'accepted');
			const inProgressKYCs = data.user?.kycs?.filter((kyc: any) => kyc.status === 'in_progress');

			if (inProgressKYCs?.length >= 1) {
				resultkyc = 'inprogress';
			}
			if (acceptedKYCs?.length >= 1) {
				resultkyc = 'true';
			}

			startTransition(() => {
				setStatus('authenticated');
			});
		});
	};

	useEffect(() => {
		// Configurar el listener de Firebase para cambios en el token
		const unsubscribe = onIdTokenChanged(FirebaseAuth, async (userAuth) => {
			if (userAuth) {
				console.log('Token detected for user:', userAuth);

				// Obtener el token y procesar los claims
				const token = await userAuth.getIdToken();
				const idTokenResult = await userAuth.getIdTokenResult();
				console.log({ idTokenResult });

				const hasuraClaim = idTokenResult.claims['https://hasura.io/jwt/claims'];
				if (hasuraClaim) {
					setStateHandler(userAuth, hasuraClaim, token);
				} else {
					// Forzar la actualización del token si no tiene los claims esperados
					const newToken = await userAuth.getIdToken(true);
					const newIdTokenResult = await userAuth.getIdTokenResult();
					const newHasuraClaim = newIdTokenResult.claims['https://hasura.io/jwt/claims'];
					setStateHandler(userAuth, newHasuraClaim, newToken);
				}
			} else {
				console.log('User signed out');
				startTransition(() => {
					setState({});
					signout();
				});
			}
		});

		// Función para calcular el tiempo restante del token
		const getTokenTimeRemainingMs = async (user: User | null) => {
			if (user) {
				const idTokenResult = await user.getIdTokenResult();
				const currentTimeMs = Date.now(); // Tiempo actual en ms
				const expTimeMs = Number(idTokenResult.claims.exp) * 1000; // Expiración en ms
				return expTimeMs - currentTimeMs; // Tiempo restante en ms
			} else {
				return 0;
			}
		};

		// Refrescar token según el tiempo restante dinámicamente
		const setupDynamicRefresh = async () => {
			const user = FirebaseAuth.currentUser;

			if (user) {
				const reducingTime = 5 * 60 * 1000; // minutes * seconds in a minute * miliseconds in a second
				const timeRemainingMs = await getTokenTimeRemainingMs(user);

				if (timeRemainingMs > reducingTime) {
					const timeToRefresh = timeRemainingMs - reducingTime;
					const totalSeconds = Math.floor(timeToRefresh / 1000);
					const hours = Math.floor(totalSeconds / 3600);
					const minutes = Math.floor((totalSeconds % 3600) / 60);
					const seconds = totalSeconds % 60;
					console.log(`Configurando refresh en ${hours}h ${minutes}m ${seconds}s`);

					// Configurar un timeout dinámico para refrescar el token
					const timeoutId = setTimeout(async () => {
						console.log('Refreshing token...');
						const newToken = await user.getIdToken(true);
						const idTokenResult = await user.getIdTokenResult();
						const hasuraClaim = idTokenResult.claims['https://hasura.io/jwt/claims'];
						setStateHandler(user, hasuraClaim, newToken);

						// Reconfigurar el timeout dinámico
						await setupDynamicRefresh();
					}, timeToRefresh);

					return timeoutId;
				} else {
					console.log('Refreshing token...');
					const newToken = await user.getIdToken(true);
					const idTokenResult = await user.getIdTokenResult();
					const hasuraClaim = idTokenResult.claims['https://hasura.io/jwt/claims'];
					setStateHandler(user, hasuraClaim, newToken);

					// Reconfigurar el timeout dinámico
					await setupDynamicRefresh();
				}
			}
			return null;
		};

		let timeoutId: NodeJS.Timeout | null = null;

		// Inicializar el primer timeout dinámico
		setupDynamicRefresh().then((r) => {
			timeoutId = r;
		});

		// Limpiar listener y timeout al desmontar
		return () => {
			unsubscribe();
			if (timeoutId) {
				clearTimeout(timeoutId);
				console.log('Limpiando timeout de refresh dinámico');
			}
		};
	}, []);

	const AppContext: AppContextInterface = {
		state,
		setState,
		user,
		setUser,
		token,
		logged,
		setLogged,
		status,
		isVerificationToastVisible,
		setIsVerificationToastVisible,
		openAuthModal,
		setOpenAuthModal,
		eventKey,
		setEventKey,
		onboarding,
		setOnboarding,
		setIsMobile,
		setIsReady,
		isMobile,
		isReady,
		setRefreshUI,
		refreshUI,
		setRefreshDataAccount,
		refreshDataAccount,
	};

	return <AppCtx.Provider value={AppContext}>{props.children}</AppCtx.Provider>;
};

export default AuthFirebaseProvider;
